import { Box, Select, styled, TextField, Typography } from '@mui/material';
import {
  BaseStyledMenuItem,
  ClearIconWrapper,
  createFilterWrapper,
  getSelectStyles,
  HoverOverlay,
  StyledClearIcon,
} from '../FilterStyles';

export { HoverOverlay, ClearIconWrapper, StyledClearIcon, getSelectStyles };

export const FilterWrapper = createFilterWrapper('default');

export const StyledMenuItem = styled(BaseStyledMenuItem)(() => ({
  padding: '14px 16px',
  minHeight: 'auto',
}));

export const DEBOUNCE_DELAY = 500;
const MENU_MIN_WIDTH = 330;
const MENU_MAX_WIDTH = 330;
const MENU_MAX_HEIGHT = 400;

export const StyledSelect = styled(Select)(() => ({
  position: 'relative',
  fontSize: 16,
  height: 36,
  zIndex: 1,

  '& .MuiSelect-standard': {
    paddingLeft: 14,
    paddingRight: 14,
    maxWidth: 180,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'flex',
    alignItems: 'center',
  },

  '& .MuiSelect-icon': {
    color: 'gray',
    marginRight: 0,
  },
}));

export const SearchTextField = styled(TextField)(({ theme }) => ({
  padding: theme.spacing(1),
  '& .MuiInputBase-root': {
    fontSize: 14,
  },
}));

export const LoaderWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  padding: theme.spacing(2),
}));

export const ItemImage = styled('img')({
  width: 40,
  height: 40,
  objectFit: 'contain',
  borderRadius: 4,
  marginRight: 12,
  flexShrink: 0,
});

export const ItemContentWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
});

export const ItemTextWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
});

export const ItemName = styled(Typography)({
  fontSize: 16,
  fontWeight: 400,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const ItemSecondaryText = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.text.secondary,
  textTransform: 'uppercase',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}));

export const DisplayLabelText = styled(Typography)({
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  maxWidth: '120px',
});

export const SearchContainer = styled(Box)(({ theme }) => ({
  position: 'sticky',
  top: 0,
  backgroundColor: theme.palette.background.paper,
  zIndex: 1,
}));

export const MenuPaperSx = {
  minWidth: `${MENU_MIN_WIDTH}px !important`,
  maxWidth: MENU_MAX_WIDTH,
  maxHeight: MENU_MAX_HEIGHT,
  '& .MuiTypography-root': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
};

export const getSelectSx = (value?: string) => getSelectStyles(!!value, 16);
